import React, { useEffect, useState } from 'react'
import { useAddPresaleInfoMutation } from './store/ReduxApis';
import { useHistory } from 'react-router-dom';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import toast, { Toaster } from 'react-hot-toast';
import DateTimePicker from 'react-datetime-picker';


function AddPresaleRound() {

    // Function to get today's date in 'DD-MM-YYYY' format
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [createPost, responseInfo] = useAddPresaleInfoMutation();
    const [presaleTitle, setPresaleTitle] = useState("")
    const [startDate, setStartDate] = useState(getCurrentDate());
    const [endDate, setEndDate] = useState(getCurrentDate());
    const [supply, setSupply] = useState("")
    const [price, setPrice] = useState("")
    const [priceinusd, setPriceUSD] = useState("")
    const [salepercentage, setSalePercentage] = useState("")
    const [MinAmount, setMinAmount] = useState("")
    const [MaxAmount, setMaxAmount] = useState("")
    const [error, setError] = useState('');
    const [errorValid, setErrorValid] = useState({});


    const history = useHistory();

    const validateDates = (newStartDate, newEndDate) => {
        if (newStartDate === newEndDate) {
            setError('Start Date and End Date cannot be the same.');
            return false;
        } else if (newStartDate > newEndDate) {
            setError('End Date should be greater than Start Date.');
            return false;
        } else {
            setError('');
            return true;
        }
    };

    const validateFields = (newStartDate, newEndDate) => {
        const errors = {};
        if (!presaleTitle.trim()) {
            errors.presaleTitle = "Presale Title is required";
        }
        if (!startDate) {
            errors.startDate = "Start Date is required";
        }
        if (!endDate) {
            errors.endDate = "End Date is required";
        }
        if (newStartDate === newEndDate) {
            errors.dateValidation = "Start Date and End Date cannot be the same.";
        } 
        else if (newStartDate > newEndDate) {
            errors.dateValidation = "End Date should be greater than Start Date.";
        }

        if (!supply || isNaN(supply)) {
            errors.supply = "Supply should be a number";
        }
        // if (!price || isNaN(price)) {
        //     errors.price = "Price should be a number";
        // }
        if (!priceinusd || isNaN(priceinusd)) {
            errors.priceinusd = "Price in USD should be a number";
        }
        if (!salepercentage || isNaN(salepercentage)) {
            errors.salepercentage = "Sale Percentage should be a number";
        }
        // if (!MinAmount || isNaN(MinAmount)) {
        //     errors.MinAmount = "Min Amount should be a number";
        // }
        // if (!MaxAmount || isNaN(MaxAmount)) {
        //     errors.MaxAmount = "Max Amount should be a number";
        // } else if (parseFloat(MinAmount) <= 0) {
        //     errors.MinAmount = "Min Amount should be greater than 0";
        // }

        // if (MinAmount && MaxAmount && !isNaN(MinAmount) && !isNaN(MaxAmount)) {
        //     if (parseFloat(MinAmount) >= parseFloat(MaxAmount)) {
        //         errors.amountValidation = "Maximum amount should be greater than minimum amount";
        //     }
        // }
       
        setErrorValid(errors);
        return Object.keys(errors).length === 0;
    };
    

    const handleStartDateChange = (e) => {
        const newStartDate = e.target.value;
        setStartDate(newStartDate);
        validateFields(newStartDate, endDate);
    };

    const handleEndDateChange = (e) => {
        const newEndDate = e.target.value;
        setEndDate(newEndDate);
        validateFields(startDate, newEndDate);
    };

    const newPost = {
        "presaleTitle": presaleTitle,
        "startDate": startDate,
        "endDate": endDate,
        "supply": supply,
        // "price": price,
        "priceinusd": priceinusd,
        "salepercentage": salepercentage,
        // "price": price,
        // "minAmount": MinAmount,
        // "maxAmount": MaxAmount,
    }



    console.log(responseInfo)

    const addUser = async (e) => {
        e.preventDefault();
        // if (!validateFields()) {
        //     return;
        // }
         if (!validateFields(startDate, endDate)) {
            return;
        }
      

        console.log("addPresale:", newPost);
        await createPost(newPost);
    };
    

    useEffect(() => {
        if (responseInfo?.data?.status === "success") {
            toast(responseInfo?.data?.message)
            setTimeout(() => history.push('/presale'), 2000);
        } else if (responseInfo?.error?.data?.status === "fail") {
            toast(responseInfo?.error?.data?.message)
        }
        else if (responseInfo?.status === "fulfilled") {
            toast(responseInfo?.data?.message)
        }

    }, [responseInfo])

    return (
        <div>
            <Toaster />

            <div className="content-wrapper">

                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6 text">
                                <h1>Add Presale</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item active">Add Presale</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6 offset-md-2">

                                <div className="card card-outline card-primary">
                                    <form onSubmit={(e) => addUser(e)}>
                                        <div className="card-body">

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='presale'> Presale Title </label>
                                                <input type="text" className="addPost" 
                                                // placeholder="Presale Title" 
                                                value={presaleTitle} 
                                                name='presaleTitle' onChange={(e) => setPresaleTitle(e.target.value)} required />
                                             {errorValid.presaleTitle && <p style={{ color: 'red' }}>{errorValid.presaleTitle}</p>}
                                            </div>

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='supply'> Supply </label>
                                                <input type="text" className="addPost" 
                                                // placeholder="Supply" 
                                                value={supply} 
                                                name='supply' onChange={(e) => setSupply(e.target.value)} required />
                                            {errorValid.supply && <p style={{ color: 'red' }}>{errorValid.supply}</p>}
                                            </div>

                                            {/* <div className="mb-3">
                                                <label className='addlabel' htmlFor='price'> Price ( BNB )</label>
                                                <input type="text" className="addPost" 
                                                // placeholder="Price" 
                                                value={price} 
                                                name='price' onChange={(e) => setPrice(e.target.value)} required />
                                           {errorValid.price && <p style={{ color: 'red' }}>{errorValid.price}</p>}
                                            </div> */}

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='price'> Price ( USD )</label>
                                                <input type="text" className="addPost" 
                                                // placeholder="Price" 
                                                value={priceinusd} 
                                                name='priceinusd' onChange={(e) => setPriceUSD(e.target.value)} required />
                                           {errorValid.priceinusd && <p style={{ color: 'red' }}>{errorValid.priceinusd}</p>}
                                            </div>

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='price'>Sale Percentage</label>
                                                <input type="text" className="addPost" 
                                                // placeholder="Price" 
                                                value={salepercentage} 
                                                name='salepercentage' onChange={(e) => setSalePercentage(e.target.value)} required />
                                           {errorValid.salepercentage && <p style={{ color: 'red' }}>{errorValid.salepercentage}</p>}
                                            </div>

                                            {/* <div className="mb-3">
                                                <label className='addlabel' htmlFor='MinAmount'> MinAmount </label>
                                                <input type="text" 
                                                 className="addPost" 
                                                 value={MinAmount} 
                                                // placeholder="MinAmount" 
                                                name='MinAmount' onChange={(e) => setMinAmount(e.target.value)} required />
                                             {errorValid.MinAmount && <p style={{ color: 'red' }}>{errorValid.MinAmount}</p>}
                                            </div>

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='MaxAmount'> MaxAmount </label>
                                                <input type="text" className="addPost" 
                                                // placeholder="MaxAmount" 
                                                value={MaxAmount} 
                                                name='MaxAmount' onChange={(e) => setMaxAmount(e.target.value)} required />
                                           
                                           {errorValid.MaxAmount && <p style={{ color: 'red' }}>{errorValid.MaxAmount}</p>}
                                           {errorValid.amountValidation && <p style={{ color: 'red' }}>{errorValid.amountValidation}</p>}
                                            </div> */}

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='startDate'> Start Date </label>
                                                <input type="date" className="addPost" 
                                                // placeholder="Start Date" 
                                                name='startDate' value={startDate} onChange={handleStartDateChange} required />
                                            {errorValid.startDate && <p style={{ color: 'red' }}>{errorValid.startDate}</p>}
                                            </div>

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='endDate'> End Date </label>
                                                <input type="date" className="addPost" 
                                                // placeholder="End Date" 
                                                name='endDate' value={endDate} onChange={handleEndDateChange} required />
                                                {errorValid.endDate && <p style={{ color: 'red' }}>{errorValid.endDate}</p>}
                                                {errorValid.dateValidation && <p style={{ color: 'red' }}>{errorValid.dateValidation}</p>}
                                            </div>

                                           

                                            <button type='submit' className="btnPost">Add Presale</button>
                                        </div>
                                    </form>

                                </div>

                            </div>
                        </div>

                    </div>

                </section>
            </div>

        </div>
    )
}

export default AddPresaleRound